const fb = require('../../firebaseConfig.js')

export default {
    state: {
        contractTypes: [],
		contractType: {},
    },
    getters: {
        contractType: (state) => {
			return state.contractType
        },
        contractTypes: (state) => {
            return state.contractTypes
        }
    },
    mutations: {
        setContractTypes(state, val) {
			state.contractTypes = val
		},
		setContractType(state, val) {
			state.contractType = val
		}
    },
    actions: {
        async fetchContractTypes({commit}) {
            await fb.contractTypesCollection.orderBy('sequence', 'asc').onSnapshot(querySnapshot => {
                let contractTypes = [];
                querySnapshot.forEach(contractType => {
                    let currentContractType = contractType.data();
                    currentContractType.id = contractType.id
                    contractTypes.push(currentContractType)
                })
                commit('setContractTypes', contractTypes)
            })
        },
        async fetchContractType({commit}, {contractTypeId}) {
            await fb.contractTypesCollection.doc(contractTypeId).get().then(res => {
                console.log(res.data(), commit)
                let currentContractType = res.data()
                currentContractType.id = contractTypeId
                commit('setContractType', currentContractType)
            })
        },
        createContractType({getters}, payload) {
            if(payload.id) {
                fb.contractTypesCollection.doc(payload.id).update({
                    name: payload.name,
                    sequence: payload.sequence,
                    type: '',
                    updatedOn: fb.fromDate(new Date()),
                    updatedBy: getters.userId
                })
                return
            }
            fb.contractTypesCollection.add({
                name: payload.name,
                sequence: payload.sequence,
                type: '',
                createdOn: fb.fromDate(new Date()),
                createdBy: getters.userId
            })
    
        },
    }
}